import axios from "axios";
import axiosRetry, { isNetworkOrIdempotentRequestError } from "axios-retry";
import { getOrElse } from "../../../_helpers/_utilities";

export default class CustomAxios {
	axiosClient;

	constructor(options) {
		const retryConfig = {
			shouldResetTimeout: true,
			retries: getOrElse(() => options.retries, 3),
			// Allow retry on timeout
			retryCondition: (error) => isNetworkOrIdempotentRequestError(error) || error.code === "ECONNABORTED",
		};
		this.axiosClient = axios.create(options);
		axiosRetry(this.axiosClient, retryConfig);
		return this;
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async get() {
		return this.axiosClient
		.get(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async post() {
		return this.axiosClient
		.post(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async patch() {
		return this.axiosClient
		.patch(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async put() {
		return this.axiosClient
		.put(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async delete() {
		return this.axiosClient
		.delete(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}

	/**
	 * Returns the data object of the response or error if failed
	 * @return {Promise<void>}
	 */
	async request() {
		return this.axiosClient
		.request(...arguments)
		.then((res) => {
			return res.data;
		})
		.catch((e) => {
			throw e;
		});
	}
}
